import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import { nonames, nameRegExp } from "../../variables/Variables";
import ActivityReasonForApplying from "../form/ActivityReasonForApplying";

export default function LegalInformation({ state, onChange }) {
  function handleChange(event) {
    const { id, value } = event.target;
    const inputElement = document.getElementById(id);
    const errorElement = inputElement.nextSibling;

    if (id === "legalName") {
      if (value.trim().length === 0) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Trust name can't be empty";
        errorElement.style.display = "block";
      } else if (!/^[ a-zA-Z0-9&-]+$/.test(value)) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Trust name could contain only letters, numbers and & - symbols";
        errorElement.style.display = "block";
      } else if (!nameRegExp.test(value.trim()) || nonames.includes(value.trim().toLowerCase())) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML =
          "The Trust name may not contain an ending such as 'LLC', 'LC', 'PLLC', 'PA', 'Corp', or 'Inc'.";
        errorElement.style.display = "block";
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    onChange(event);
  }

  return (
    <>
      <h5>Legal information</h5>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip
            id="overlay-example"
            className="helpTooltip"
            style={{ fontSize: "16px", fontFamily: "Source Sans Pro" }}
          >
            <strong>Legal Name of Trust</strong>
            <br />
            Special instructions for entering the legal name of your trust:
            <ol>
              <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro", fontWeight: "normal" }}>
                Omit any names of trustees.
              </li>
              <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro", fontWeight: "normal" }}>
                Place the individual&apos;s name at the beginning of your trust name.
              </li>
              <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro", fontWeight: "normal" }}>
                Do not enter the words &apos;date&apos; or &apos;dated&apos;.
              </li>
              <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro", fontWeight: "normal" }}>
                Do not enter the alpha month, replace with corresponding numeric character.
              </li>
              <li style={{ fontSize: "16px", fontFamily: "Source Sans Pro", fontWeight: "normal" }}>
                Omit the word &apos;The&apos; from the beginning of your trust name.
              </li>
            </ol>
            The only punctuation and special characters allowed are hyphen (-) and ampersand (&).
            <br />
            <br />
            The legal name may not contain any of the following endings: Corp, LLC, PLLC, LC, Inc, PA.
          </Tooltip>
        }
      >
        <Form.Group controlId="legalName">
          <Form.Label>Trust name</Form.Label>
          <Form.Control
            required
            data-hj-allow
            type="text"
            placeholder="Name"
            pattern="(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][lL][lL][cC]$))(?!.*(?:[ ][lL][cC]$))(?!.*(?:[ ][pP][lL][lL][cC]$))(?!.*(?:[ ][iI][nN][cC]$))^[ a-zA-Z0-9\\&-]+$"
            maxLength="70"
            defaultValue={state.legalName}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">Please provide a valid trust name</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      <Form.Group controlId="trustType">
        <Form.Label>Type of Trust</Form.Label>
        <Form.Control as="select" required value={state.trustType} onChange={onChange} >
          <option value="">Select type of Trust</option>
          <option value="BankruptcyEstate">Bankruptcy Estate (Individual)</option>
          <option value="CharitableLeadAnnuityTrust">Charitable Lead Annuity Trust</option>
          <option value="CharitableLeadUnitTrust">Charitable Lead Unitrust</option>
          <option value="CharitableRemainderAnnuityTrust">Charitable Remainder Annuity Trust</option>
          <option value="CharitableRemainderUnitrust">Charitable Remainder Unitrust</option>
          <option value="Conservatorship">Conservatorship</option>
          <option value="Custodianship">Custodianship</option>
          <option value="Escrow">Escrow</option>
          <option value="FNMA">FNMA (Fannie Mae)</option>
          <option value="GNMA">GNMA (Ginnie Mae)</option>
          <option value="Guardianship">Guardianship</option>
          <option value="IrrevocableTrust">Irrevocable Trust</option>
          <option value="PooledIncomeFund">Pooled Income Fund</option>
          <option value="QualifiedFuneralTrust">Qualified Funeral Trust</option>
          <option value="Receivership">Receivership</option>
          <option value="RevocableTrust">Revocable Trust</option>
          <option value="SettlementFund">Settlement Fund</option>
          <option value="Trust">Trust (All Others)</option>
        </Form.Control>
        <Form.Control.Feedback type="invalid">Please provide a valid trust type</Form.Control.Feedback>
      </Form.Group>
      {state.trustType==="Escrow" ? <ActivityReasonForApplying state={state} onChange={onChange}/> : null}
    </>
  );
}
